import React from "react";
import { injectIntl } from "react-intl";
var SkipToContent = function(param) {
    var intl = param.intl;
    return /*#__PURE__*/ React.createElement("ul", {
        className: "skip-to-content noindex"
    }, /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement("a", {
        href: "#header",
        className: "hide-skip-to-content"
    }, intl.formatMessage({
        id: "ui.header",
        defaultMessage: "Header"
    }))), /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement("a", {
        href: "#navigation",
        className: "hide-skip-to-content"
    }, intl.formatMessage({
        id: "ui.navigation",
        defaultMessage: "Navigation"
    }))), /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement("a", {
        href: "#main",
        className: "hide-skip-to-content"
    }, intl.formatMessage({
        id: "ui.main_content",
        defaultMessage: "Main content"
    }))), /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement("a", {
        href: "#footer",
        className: "hide-skip-to-content"
    }, intl.formatMessage({
        id: "ui.footer",
        defaultMessage: "Footer"
    }))));
};
export default injectIntl(SkipToContent);
